import validate from "E:/workspace/roncoo/roncoo-web/node_modules/nuxt/dist/pages/runtime/validate.js";
import cas_45login_45redirect_45global from "E:/workspace/roncoo/roncoo-web/middleware/cas-login-redirect.global.js";
import insight_45web_45global from "E:/workspace/roncoo/roncoo-web/middleware/insight-web.global.js";
import router_45global from "E:/workspace/roncoo/roncoo-web/middleware/router.global.js";
export const globalMiddleware = [
  validate,
  cas_45login_45redirect_45global,
  insight_45web_45global,
  router_45global
]
export const namedMiddleware = {}